export default {
	EARLY_SHIFT_START: 'Early shift start',
	EARLY_SHIFT_END: 'Early shift end',
	LATE_SHIFT_START: 'Late shift start',
	LATE_SHIFT_END: 'Late shift end',
	BREAK_TOO_SHORT: 'Break too short',
	BREAK_TOO_LONG: 'Break too long',
};
